import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Tabs, Button, message } from 'antd';
import MySummary from './components/MySummary';
import MySubscriptionsTable from './components/MySubscriptionsTable';
import { fetchUserSubscriptions } from '../../../User/UserActions';
import { userSubscriptionsSelector } from '../../../User/UserSelectors';
import '../BrokerageSubscriptions/BrokerageSubscriptions.scss';

const { TabPane } = Tabs;

const exportToCsv = subscriptions => {
  if (!subscriptions || !subscriptions.length) {
    message.warning('No subscriptions to export.');
    return;
  }
  const headers = ['Company', 'Plan Name', 'Activate Date', 'Expiry Date', 'Email', 'Status', 'Revoked'];
  const rows = subscriptions.map(s => [
    s.organisationName || '',
    s.planName || '',
    s.activeDate || '',
    s.expiryDate || '',
    s.assignedTo || '',
    s.status || (s.isExpired ? 'Expired' : 'Active'),
    s.isRevoked ? 'Yes' : 'No',
  ]);
  const escapeCell = v => {
    const s = v == null ? '' : String(v);
    return `"${s.replace(/"/g, '""')}"`;
  };
  const csv = [headers, ...rows].map(r => r.map(escapeCell).join(',')).join('\n');
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'my-subscriptions.csv';
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 800);
  message.success('Export started — check your downloads folder.');
};

const MySubscriptions = ({ subscriptions, fetchUserSubscriptions }) => {
  useEffect(() => {
    fetchUserSubscriptions();
  }, [fetchUserSubscriptions]);

  const tabBarExtra = (
    <Button
      icon="export"
      size="small"
      className="bsub-export-btn"
      onClick={() => exportToCsv(subscriptions)}
    >
      Export
    </Button>
  );

  return (
    <div className="component-wrapper">
      <Row gutter={20} type="flex">
        <Col span={24}>
          <MySummary />
        </Col>
        <Col span={24}>
          <div className="bsub-tabs-container">
            <Tabs
              defaultActiveKey="mySubscription"
              tabBarExtraContent={tabBarExtra}
            >
              <TabPane key="mySubscription" tab="My Subscriptions">
                <MySubscriptionsTable subscriptions={subscriptions} />
              </TabPane>
            </Tabs>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = state => ({
  subscriptions: userSubscriptionsSelector(state),
});

const mapDispatchToProps = { fetchUserSubscriptions };

export default connect(mapStateToProps, mapDispatchToProps)(MySubscriptions);
